// removed by extract-text-webpack-plugin
module.exports = {"link":"_25irHcd"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Header/HomeLogo/index.css
// module id = ./template/components/Header/HomeLogo/index.css
// module chunks = client.sitechrome